import {
    BreakpointObserver,
    Breakpoints,
    BreakpointState
} from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GoogleAnalyticsService } from '../shared/service/google-analytics.service';

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    standalone: false
})
export class AccountComponent implements OnInit {
    xSmall$: Observable<boolean> = this._breakpoints
        .observe([Breakpoints.XSmall])
        .pipe(map((value: BreakpointState) => value.matches));

    constructor(
        private readonly _breakpoints: BreakpointObserver,
        private readonly _location: Location,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}
    ngOnInit(): void {
        this._googleAnalyticsService.pageView('My Account');
    }
    goBack() {
        this._location.back();
    }
}
